module.exports = __webpack_public_path__ + "img/原理图.0f0734cb.svg";